/* eslint-disable react-refresh/only-export-components */
import React, { createContext } from 'react'
import useAuth from '../hooks/useAuth'
import useSupabaseAuth from '../hooks/useSupabaseAuth'
import { isSupabaseAuthEnabled } from '../lib/supabase'
import type { AuthContextType } from '../types/auth'

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

interface AuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  // Call both hooks unconditionally to avoid React hooks rule violations
  const supabaseAuth = useSupabaseAuth()
  const mockAuth = useAuth()

  // Use Supabase auth if enabled, otherwise use mock auth
  const auth = isSupabaseAuthEnabled ? supabaseAuth : mockAuth

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}
